import { PickSampleExt } from "@novorender/api";
import { ReadonlyVec3 } from "gl-matrix";
import { createContext, Dispatch, MutableRefObject } from "react";

export type LastPickSample = PickSampleExt & {
    // Some data from hovered entity
    hoverEntity?: {
        connectionPoint?: ReadonlyVec3;
    };
};

export type State = LastPickSample | null;

export const initialState: State = null;

enum ActionTypes {
    Set,
}

function set(state: null | State) {
    return {
        type: ActionTypes.Set as const,
        state,
    };
}

export const actions = { set };

type Actions = ReturnType<(typeof actions)[keyof typeof actions]>;
export type DispatchLastPickSample = Dispatch<Actions>;
export type LazyContextType = MutableRefObject<State>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StateContext = createContext<State>(undefined as any);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyStateContext = createContext<LazyContextType>(undefined as any);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DispatchContext = createContext<DispatchLastPickSample>(undefined as any);
export function reducer(_state: State, action: Actions): State {
    switch (action.type) {
        case ActionTypes.Set: {
            return action.state;
        }
        default: {
            throw new Error(`Unhandled action type`);
        }
    }
}
